<template>
    <div>
        <h1 class="text-5xl text-teal-800">
            Dashboard
        </h1>

        <p>Dit is het dashboard voor de Humbold Scraper/Admin omgeving.</p>

        <div class="flex items-start justify-left mt-5 -mx-3">

            <inertia-link
                href="/joboffers?orderBy=sustainability_score&sortOrder=desc&reviewed=false&filter_origin=scraper"
                class="block group px-5 py-3 w-1/3 rounded shadow mx-3 hover:shadow-xl hover:text-white text-center"
                :class="stats.unreviewed ? 'bg-orange-400 hover:bg-orange-600' : 'bg-white hover:bg-teal-600'"
            >
                <div class="text-2xl">{{ stats.unreviewed | numberFormatNL }}</div>
                <div class="">Nog niet beoordeelde vacatures.</div>
            </inertia-link>

            <inertia-link
                href="/joboffers?orderBy=sustainability_score&sortOrder=desc&published=unknown"
                class="block group bg-white px-5 py-3 w-1/3 rounded shadow mx-3 hover:shadow-xl hover:bg-teal-600 hover:text-white text-center"
            >
                <div class="text-2xl">{{ stats.numScraperPages | numberFormatNL }}</div>
                <div class="">Pagina's worden gemonitored.</div>
            </inertia-link>

            <inertia-link
                href="/joboffers?orderBy=sustainability_score&sortOrder=desc&published=unknown"
                class="block group bg-white px-5 py-3 w-1/3 rounded shadow mx-3 hover:shadow-xl hover:bg-teal-600 hover:text-white text-center"
            >
                <div class="text-2xl">{{ stats.published | numberFormatNL }}</div>
                <div class="">Duurzame vacatures actief.</div>
            </inertia-link>

        </div>

        <div class="flex items-start justify-left mt-5 -mx-3">

            <inertia-link
                href="/users?orderBy=created_at&sortOrder=desc"
                class="block group px-5 py-3 w-1/4 rounded shadow mx-3 hover:shadow-xl hover:text-white text-center bg-white hover:bg-teal-600"
            >
                <div class="text-2xl">{{ stats.users | numberFormatNL }}</div>
                <div class="">Werkzoekenden</div>
            </inertia-link>

                <inertia-link
                    href="/users?orderBy=created_at&sortOrder=desc&filter_has_alerts=yes"
                    class="block group px-5 py-3 w-1/4 rounded shadow mx-3 hover:shadow-xl hover:text-white text-center bg-white hover:bg-teal-600"
                >
                    <div class="text-2xl">{{ stats.alerts | numberFormatNL }}</div>
                    <div class="">Alerts actief</div>
                </inertia-link>

            <inertia-link
                href="/joboffers?orderBy=created_at&sortOrder=desc&filter_origin=site"
                class="block group px-5 py-3 w-1/4 rounded shadow mx-3 hover:shadow-xl hover:text-white text-center bg-white hover:bg-teal-600"
            >
                <div class="text-2xl">{{ stats.site | numberFormatNL }}</div>
                <div class="">Vacatures vanuit de site</div>
            </inertia-link>

            <inertia-link
                href="/companies?haslogo=no&orderBy=job_offers_count&sortOrder=desc"
                class="block group px-5 py-3 w-1/4 rounded shadow mx-3 hover:shadow-xl hover:text-white text-center"
                :class="stats.companiesWithoutLogo ? 'bg-orange-400 hover:bg-orange-600' : 'bg-white hover:bg-teal-600'"
            >
                <div class="text-2xl">{{ stats.companiesWithoutLogo | numberFormatNL }}</div>
                <div class="">Bedrijven met vacatures maar zonder logo.</div>
            </inertia-link>

        </div>

        <div class="mt-8">
            <h2 class="text-2xl mt-5 mb-1">Laatste scraper runs</h2>
            <scraper-runs-table :scraper-runs="scraperRuns" class="mt-3"></scraper-runs-table>
        </div>
    </div>
</template>

<script>
import ScraperRunsTable from "@/admin/Components/Scrapers/ScraperRunsTable";

import Layout from "@/admin/Shared/Layout";

export default {
    metaInfo: { title: "Dashboard" },
    layout: Layout,
    components: {
        ScraperRunsTable
    },
    props: {
        stats: Object,
        scraperRuns: Array
    }
};
</script>
